var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder } from "@angular/forms";
import { ConfigService, EnvironmentService, P4mService, PosConnectionService, RoutingService, SentryService, ToastService, TranslateService, } from "shared/lib/common/services";
import { LoginPage as SharedLoginPage } from "shared/lib/common/pages";
import { Platform } from "@ionic/angular";
import { AdminService, DeviceMountingService } from "shared/lib/v2/services";
import { SharedRoutes } from "shared/lib/common/enums";
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage(_translate, _fb, _admin, _config, _toast, _sentry, _p4m, _platform, _routing, _environment, _deviceMountingService, _posConnectionService) {
        var _this = _super.call(this, _translate, _fb, _admin, _config, _toast, _sentry, _p4m, _platform, _routing, _environment) || this;
        _this._translate = _translate;
        _this._fb = _fb;
        _this._admin = _admin;
        _this._config = _config;
        _this._toast = _toast;
        _this._sentry = _sentry;
        _this._p4m = _p4m;
        _this._platform = _platform;
        _this._routing = _routing;
        _this._environment = _environment;
        _this._deviceMountingService = _deviceMountingService;
        _this._posConnectionService = _posConnectionService;
        return _this;
    }
    LoginPage.prototype.ionViewWillEnter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.params = this._routing.getUrlParams();
                        if (!(this.params.email && this.params.password && this.params.interactionId)) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.login(this.params.email, this.params.password)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.mountDevice(this.params.interactionId)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        _super.prototype.ionViewWillEnter.call(this);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _super.prototype.ionViewWillEnter.call(this);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    LoginPage.prototype.mountDevice = function (appInteractionId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, _b, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this._deviceMountingService.mount(appInteractionId)];
                    case 1:
                        res = _c.sent();
                        if (!(res.ok === true)) return [3 /*break*/, 6];
                        _b = (_a = this._config).setMountingConfig;
                        return [4 /*yield*/, this._deviceMountingService.parseMountingConfigV1ToV2(res.response)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        this._posConnectionService.connectToSocket(res.response.deviceKey);
                        this.translate.setLanguage(res.response.profile.language === "de" ? "de" : "en");
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ video: true })];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _c.sent();
                        this.toast.show("Camera access denied", "error");
                        return [3 /*break*/, 6];
                    case 6:
                        this._routing.goForward([SharedRoutes.screenSaver]);
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginPage;
}(SharedLoginPage));
export { LoginPage };
